export const CANCEL_BOOKING = "CANCEL_BOOKING";
export const GET_BOOKING_DATA = "GET_BOOKING_DATA";
export const GET_SELECTED_PLAYER = "GET_SELECTED_PLAYER";
export const GET_LISTING_BOOKING_DATA = "GET_LISTING_BOOKING_DATA";
